import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { BROKER_PATHS } from './paths';

/**
 * Брокер сообщений: узел-хаб с потоками в обе стороны (Kafka). Контур в стиле
 * Material «device hub», чтобы не спорить с соседними иконками сайдбара.
 */
export const BrokerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {BROKER_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
